export const WEBSITE_URL = 'https://www.pfsbc.com/';
export const TERMS_OF_USE_URL = 'https://www.pfsbc.com/legal-docs/terms-of-use';
export const PRIVACY_POLICY_URL =
  'https://www.pfsbc.com/legal-docs/privacy-policy';
export const EMAIL_ADDRESS = 'support@pfsbc.com';
